<template>
  <div class="collection-form" v-if="!(!collectionInfo.is_valid || this.collectionInfo.is_closed || this.collectionInfo.is_expired)">
    <div class="btn primary-bgcolor" @click="handleUploadFile">{{$route.query.uploadSuccess ? '继续上传' : '上传文件'}}</div>

    <van-actionsheet
      class="collection-actionsheet"
      v-model="showUploadSheet"
      @click-overlay="clearActionSheet"
    >
      <ul class="collection-sheet-wrapper">
        <li
          v-for="(action) of actions"
          :class="['action-item']"
          :key="action.id"
          @click="onSelect(action)"
        >

            <div class="item-icon"><img :src="action.icon()"/></div>
            {{action.name}}
        </li>
      </ul>
    </van-actionsheet>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import eventBus from '../utils/eventBus'

export default {
  name: 'CollectionForm',
  i18n,
  components: {
  },
  props: {
    collectionInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showUploadSheet: false,
      actions: [
        {
          name: '从亿方云选择',
          icon: () => { return require('@/assets/embedAppPageImg/fangcloud.svg') },
          id: 'fangcloud'
        },
        {
          name: '相册',
          icon: () => { return require('@/assets/embedAppPageImg/photo.svg') },
          id: 'photo'
        },
        {
          name: '相机',
          icon: () => { return require('@/assets/embedAppPageImg/camera.svg') },
          id: 'camera'
        },
        {
          name: '本地文件',
          icon: () => { return require('@/assets/embedAppPageImg/local.svg') },
          id: 'localFile'
        }
      ],
      uploadFiles: {}
    }
  },
  watch: {
    $route (to, from) {
      this.showUploadSheet = !!to.query.showUploadSheet
    },
    showUploadSheet (val, oldVal) {
      if (!val && oldVal && this.$route.query.showUploadSheet) {
        this.$router.go(-1)
      }
    }
  },
  created () {
    eventBus.addListener('fileFromCloud', this.handleUploaded)
    eventBus.addListener('fileFromPhoto', this.handleUploaded)
    eventBus.addListener('fileFromCamera', this.handleUploaded)
    eventBus.addListener('fileFromLocal', this.handleUploaded)
  },
  methods: {
    handleUploadFile () {
      if (!this.collectionInfo.is_valid || this.collectionInfo.is_closed || this.collectionInfo.is_expired) return
      this.toggleQuery('showUploadSheet')
    },
    clearActionSheet () {
      this.$router.go(-1)
    },
    onSelect (item) {
      const { id } = item

      let message = {}
      switch (id) {
        case 'fangcloud':
          message = {
            'method': 'fileFromCloud'
          }
          break
        case 'camera':
          message = {
            'method': 'fileFromCamera'
          }
          break
        case 'photo':
          message = {
            'method': 'fileFromPhoto'
          }
          break
        case 'localFile':
          message = {
            'method': 'fileFromLocal'
          }
          break
        default:
          break
      }

      // eslint-disable-next-line no-undef
      fangcloud.postMessage(JSON.stringify({...message, 'action': 'collection', 'params': this.collectionInfo, 'max': 50}))
    },
    handleUploaded (res) {
      let isCopy = { isCopy: false }
      if (['fileFromCloud'].includes(res.method)) {
        isCopy = { isCopy: true }
      }
      console.log('handleUploaded...', res, isCopy, {...res, ...isCopy})
      this.$emit('uploaded-file', {...res, ...isCopy})
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.collection-form {
  display: flex;
  align-items: center;
  width: 100%;
  & .btn {
    flex: 1 1 auto;
    margin: 8px 20px;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    border-radius: 4px;
    background-color: var(--btnPrimaryColor);
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
  }

  & .collection-actionsheet {
    height: 136px;
    border-radius: 16px 16px 0px 0px;
    & .van-actionsheet__content {
      flex-direction: row;
    }
    & .collection-sheet-wrapper {
      display: flex;
      height: 136px;
      background-color: #fff;
      flex: 1 1 auto;
      padding: 32px 0 16px 0;
      align-items: center;
      & .action-item {
        height: auto;
        line-height: normal;
        flex-grow: 1;
        flex-direction: column;
        text-align: center;
        align-items: center;
        color: var(--fontBasicColor);
        font-weight: 600;
        font-size: 12px;
        padding-left: 0;
        position: relative;

        & .item-icon {
          width: 56px;
          height: 56px;
          margin: 0 auto 12px;
        }

        & .select-local-file {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          opacity: 0;
          z-index: 999;
        }
      }
    }
  }
}
</style>
